import {Paragraph as ParagraphExtension} from "@tiptap/extension-paragraph";

export default class Paragraph {

    constructor() {

    }

    static create() {
        return new Paragraph();
    }

    getExtensions() {
        return [ParagraphExtension];
    }
}